/* Mezcla las tarjetas del catálogo de Ricoseller USA al final de la grilla
   de cada colección de Argentina, sin separador ni aviso: se mezclan y sólo
   las distingue el cartelito. Los datos salen de catalogo-usa.json, que
   se regenera solo todos los días (ver ~/ricoseller-catalogo-usa).

   Se pinta del lado del navegador a propósito: así estos productos no entran
   al HTML y Google no enfrenta ricoseller.net con us.ricoseller.net por el
   mismo producto.

   OJO con el observador: pintar() toca la misma grilla que el MutationObserver
   vigila, así que hay que desconectarlo antes de tocar el DOM y reconectarlo
   después. Si no, cada repintado se dispara a sí mismo y queda un bucle
   infinito cada 80ms (medido: 38 repintados en 3 segundos).

   Lo que no se puede: los contadores al lado de cada filtro ("Nike (269)")
   los calcula Shopify en el servidor y no incluyen estos productos. */
(function () {
  var FUENTE = document.documentElement.getAttribute("data-catalogo-usa-json");
  if (!FUENTE) return;

  var datos = null;
  var observador = null;
  var TOPE = 48;

  function pesos(n) {
    return "$" + Number(n).toLocaleString("es-AR");
  }

  function valores(params, clave) {
    var out = [];
    params.forEach(function (v, k) {
      if (k === clave) out.push(v);
    });
    return out;
  }

  /* Marca y atleta viajan en la URL como id de metaobjeto ARGENTINO, así que
     hay que traducirlos a nombre para poder comparar contra los de USA. */
  function nombres(ids, mapa) {
    return ids.map(function (id) { return mapa[id]; }).filter(Boolean);
  }

  function coleccionActual() {
    var m = location.pathname.match(/\/collections\/([^/?]+)/);
    return m ? m[1] : null;
  }

  function filtrar() {
    var p = new URLSearchParams(location.search);
    var col = coleccionActual();
    var talles = valores(p, "filter.v.option.talla del calzado");
    var marcas = nombres(valores(p, "filter.p.m.custom.marca"), datos.marcas);
    var atletas = nombres(valores(p, "filter.p.m.custom.atletas"), datos.atletas);
    var soloStock = valores(p, "filter.v.availability").indexOf("1") > -1;

    return datos.productos.filter(function (x) {
      if (col && col !== "all" && (x.c || []).indexOf(col) === -1) return false;
      if (soloStock && !x.s) return false;
      if (marcas.length && marcas.indexOf(x.m) === -1) return false;
      if (atletas.length && atletas.indexOf(x.a) === -1) return false;
      if (talles.length && !talles.some(function (t) {
        return (x.z || []).indexOf(t) > -1;
      })) return false;
      return true;
    });
  }

  function tarjeta(x) {
    var li = document.createElement("li");
    li.className = "grid__item catalogo-usa__item" + (x.s ? "" : " catalogo-usa__item--agotado");
    li.setAttribute("data-catalogo-usa-item", "");
    var img = x.i.indexOf("?") > -1 ? x.i + "&width=533" : x.i + "?width=533";
    var precio = x.s
      ? pesos(x.p)
      : '<span class="catalogo-usa__agotado">Agotado</span>';
    li.innerHTML =
      '<div class="card-wrapper product-card-wrapper underline-links-hover">' +
      '<div class="card card--standard card--media" style="--ratio-percent:100.0%;">' +
      '<div class="card__inner color-scheme-2 gradient ratio" style="--ratio-percent:100.0%;">' +
      '<span class="label-stock-usa">Stock 🇺🇸</span>' +
      '<div class="card__media"><div class="media media--transparent">' +
      '<img src="' + img + '" alt="" loading="lazy" width="533" height="533">' +
      '</div></div></div>' +
      '<div class="card__content"><div class="card__information">' +
      '<h3 class="card__heading h5"><a class="full-unstyled-link" href="' +
      datos.destino + x.h + '" rel="noopener">' + x.t + '</a></h3>' +
      '<p class="producto-categoria">Calzado de básquet</p>' +
      '<div class="card-information"><div class="price"><div class="price__container">' +
      '<div class="price__regular"><span class="price-item price-item--regular">' +
      precio + '</span></div></div></div></div>' +
      '</div></div></div></div>';
    return li;
  }

  function pintar() {
    var grid = document.getElementById("product-grid");
    if (!grid || !datos) return;

    /* Desconectar antes de tocar el DOM: si no, estos cambios despiertan al
       observador que llamó a pintar() y el repintado no se detiene nunca. */
    if (observador) observador.disconnect();

    grid.querySelectorAll(
      "[data-catalogo-usa-item], [data-catalogo-usa-mas]"
    ).forEach(function (n) { n.remove(); });

    var todas = filtrar();
    var lista = todas.slice(0, TOPE);

    if (lista.length) {
      var frag = document.createDocumentFragment();
      lista.forEach(function (x) { frag.appendChild(tarjeta(x)); });
      grid.appendChild(frag);
    }

    if (observador) conectar();
  }

  /* El scroll infinito y los filtros de Dawn vuelven a dibujar la grilla por
     AJAX; cuando eso pasa hay que repintar para quedar al final de nuevo. */
  function conectar() {
    var cont = document.getElementById("ProductGridContainer") ||
               document.getElementById("product-grid");
    if (!cont) return;
    observador.observe(cont.parentNode || cont, { childList: true, subtree: true });
  }

  function observar() {
    var cont = document.getElementById("ProductGridContainer") ||
               document.getElementById("product-grid");
    if (!cont) return;
    observador = new MutationObserver(function () {
      clearTimeout(observar._t);
      observar._t = setTimeout(pintar, 80);
    });
    conectar();
  }

  fetch(FUENTE)
    .then(function (r) { return r.json(); })
    .then(function (d) { datos = d; observar(); pintar(); })
    .catch(function () {});

  window.addEventListener("popstate", function () { setTimeout(pintar, 80); });
})();

